export default (meter: number) => (meter || 0) / 1000 * 0.18
